/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.61
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ArticleEntity from './ArticleEntity';

/**
 * The AuthorEntity model module.
 * @module model/AuthorEntity
 * @version 1.0.1
 */
export default class AuthorEntity {
  /**
   * Constructs a new <code>AuthorEntity</code>.
   * @alias module:model/AuthorEntity
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AuthorEntity</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AuthorEntity} obj Optional instance to populate.
   * @return {module:model/AuthorEntity} The populated <code>AuthorEntity</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AuthorEntity();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('displayName'))
        obj.displayName = ApiClient.convertToType(data['displayName'], 'String');
      if (data.hasOwnProperty('displayNameEn'))
        obj.displayNameEn = ApiClient.convertToType(data['displayNameEn'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('descriptionEn'))
        obj.descriptionEn = ApiClient.convertToType(data['descriptionEn'], 'String');
      if (data.hasOwnProperty('imgUrl'))
        obj.imgUrl = ApiClient.convertToType(data['imgUrl'], 'String');
      if (data.hasOwnProperty('articleEntities'))
        obj.articleEntities = ApiClient.convertToType(data['articleEntities'], [ArticleEntity]);
      if (data.hasOwnProperty('editedArticleEntities'))
        obj.editedArticleEntities = ApiClient.convertToType(data['editedArticleEntities'], [ArticleEntity]);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
AuthorEntity.prototype.id = undefined;

/**
 * @member {String} displayName
 */
AuthorEntity.prototype.displayName = undefined;

/**
 * @member {String} displayNameEn
 */
AuthorEntity.prototype.displayNameEn = undefined;

/**
 * @member {String} description
 */
AuthorEntity.prototype.description = undefined;

/**
 * @member {String} descriptionEn
 */
AuthorEntity.prototype.descriptionEn = undefined;

/**
 * @member {String} imgUrl
 */
AuthorEntity.prototype.imgUrl = undefined;

/**
 * @member {Array.<module:model/ArticleEntity>} articleEntities
 */
AuthorEntity.prototype.articleEntities = undefined;

/**
 * @member {Array.<module:model/ArticleEntity>} editedArticleEntities
 */
AuthorEntity.prototype.editedArticleEntities = undefined;

